import { render } from "./BrandMappingDialog.vue?vue&type=template&id=29e8596c"
import script from "./BrandMappingDialog.vue?vue&type=script&lang=js"
export * from "./BrandMappingDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__